import dayjs from 'dayjs';
import { useFormikContext } from 'formik';
import { Form, Row } from 'react-bootstrap';

import FormField from '@components/Form/FormField';
import { IFinancialAssistanceForm, InsuranceStatus } from '@customTypes/requisition';

const PatientInformationFieldSet = () => {
  const { errors, touched, submitCount, setFieldValue } = useFormikContext<IFinancialAssistanceForm>();

  return (
    <fieldset
      id='fset_patientInformation'
      aria-describedby='fset_patientInformationDesc'
      className='patient-information-fieldset'
    >
      <legend className='text-center'>Patient Information</legend>
      <Row>
        <FormField cols={6} name='first_name' helperText='First name of the patient' required />
        <FormField cols={6} name='last_name' helperText='Last name of the patient' required />
      </Row>
      <Row>
        <FormField
          cols={6}
          name='date_of_birth'
          helperText="Patient's date of birth"
          label='Date of birth'
          type='date'
          inputProps={{
            pattern: '[0-9]{4}-[0-9]{2}-[0-9]{2}',
            max: dayjs().format('YYYY-MM-DD'),
          }}
          required
        />
        <FormField
          cols={6}
          name='requisition_id'
          helperText='The order ID can be found on the order receipt'
          label='Order ID'
          inputProps={{ placeholder: 'RQ12345' }}
        />
      </Row>
      <fieldset id='fset_insurance' className='d-flex mt-3'>
        <legend className='mb-0 fs-sm fw-medium me-2 w-auto'>Does the patient have health insurance?*</legend>
        {Object.values(InsuranceStatus).map((rVal, index) => (
          <Form.Check
            key={'radio_' + index}
            type='radio'
            inline
            id={'insurance_status_' + index}
            name='insurance_status'
            label={rVal === InsuranceStatus.INSURED ? 'Yes' : 'No'}
            className='fs-sm mb-0'
            value={rVal}
            onChange={() => setFieldValue('insurance_status', rVal)}
            isInvalid={(touched.insurance_status || submitCount > 0) && !!errors.insurance_status}
          />
        ))}
      </fieldset>
    </fieldset>
  );
};

export default PatientInformationFieldSet;
